import React from 'react'
import styled from 'styled-components'
import { StyledEmailWrapper } from '../EmailSummary/StyledContainers'
import WidgetContainer from '../../../containers/WidgetContainer'
import { login } from '../../../utils/Login'
import { DEVICES } from '../../../../constants'

const StyledIcon = styled.img`
  width: 32px;
  height: 32px;
  margin: auto;
`

const StyledTextWrapper = styled.div`
  gap: 4px;
  display: flex;
  flex-direction: column;
`

const StyledText = styled.span`
  font-weight: 500;
  line-height: 22px;
  color: ${props => props.theme.email.identita.textColor}
`

const StyledButton = styled.button`
  border-radius: 8px;
  padding: 4px 16px;
  background-color: ${props => props.theme.email.identita.buttonColor};
  color: ${props => props.theme.email.identita.buttonTextColor};
  border-width: 0 0 2px 0;
  border-color: ${props => props.theme.email.identita.textColor};
  font-weight: 600;
  font-size: 15px;
  letter-spacing: .5px;
  
  &:hover {
    text-decoration: underline;
    background-color: ${props => props.theme.email.identita.buttonHoverColor};
  }
`

const StyledLink = styled.a`
  font-weight: 600;
  font-size: 12px;
  color: ${props => props.theme.email.full.link};
  letter-spacing: .2px;
  
  &:hover {
    color: ${props => props.theme.email.full.link};
  }
`

export const LoggedOutEmail = (props) => {
  const {
    activeDynamicLayout,
    ecoIdentity: {
      clientId,
      login: {
        location: loginLocation
      },
      registration: {
        location: registrationDomain
      }
    },
    widget,
    domain
  } = props

  const handleLogin = () => {
    login({ loginLocation, clientId, returnURL: domain })
  }

  return (
    <WidgetContainer widget={widget} showBottomLine={false} hideTitle={activeDynamicLayout === DEVICES.MOBILE}>
      <StyledEmailWrapper>
        <StyledTextWrapper>
          <StyledIcon src={`${STATICS_PATH}images/email/mail.svg`}/>
          <StyledText>Přihlašte se ke svému účtu</StyledText>
        </StyledTextWrapper>
        <StyledButton onClick={handleLogin}>Přihlásit se</StyledButton>
        <StyledLink href={registrationDomain}>Založit nový účet</StyledLink>
      </StyledEmailWrapper>
    </WidgetContainer>
  )
}
